import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { LeadsTable } from "@/pages/DashboardOverview";

export default function LeadsPage() {
  const [leads, setLeads] = useState(null);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/dashboard/leads?limit=200");
      setLeads(data);
    })();
  }, []);

  return (
    <DashboardLayout>
      <div className="mb-8">
        <div className="label-eyebrow text-[#002FA7]">Leads</div>
        <h1 className="text-4xl tracking-tight font-black text-[#111827]">All captured customers</h1>
      </div>

      <div className="card-flat p-6">
        {leads === null ? <div className="h-32 animate-pulse bg-[#F9FAFB] rounded" /> : <LeadsTable leads={leads} />}
      </div>
    </DashboardLayout>
  );
}
